import { render, staticRenderFns } from "./assetLedgerBaseInfo.vue?vue&type=template&id=0c348ed0&scoped=true"
import script from "./assetLedgerBaseInfo.vue?vue&type=script&lang=js"
export * from "./assetLedgerBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./assetLedgerBaseInfo.vue?vue&type=style&index=0&id=0c348ed0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c348ed0",
  null
  
)

export default component.exports